<template>
    <div>
        <b-form-group v-bind="$attrs">
            <b-form-radio-group
                v-model="intervalFilter"
                class="w-100"
                :options="intervalFilters"
                button-variant="outline-secondary"
                :size="size"
                buttons
                @change="onChange"
            />
        </b-form-group>
        <b-form-row v-if="intervalFilter === 'custom'">
            <b-col xl="6" cols="12">
                <b-form-group
                    label="Data de início"
                    :label-for="`id_start_date_${baseId}`"
                >
                    <simbar-date-picker
                        :id="`id_start_date_${baseId}`"
                        v-model="startDate"
                        :disabled="disabled"
                        @input="onChange"
                    />
                </b-form-group>
            </b-col>
            <b-col xl="6" cols="12">
                <b-form-group
                    label="Data de fim"
                    :label-for="`id_end_date_${baseId}`"
                >
                    <simbar-date-picker
                        :id="`id_end_date_${baseId}`"
                        v-model="endDate"
                        :disabled="disabled"
                        @input="onChange"
                    />
                </b-form-group>
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
import formatISO from "date-fns/formatISO";
import subWeeks from "date-fns/subWeeks";
import subMonths from "date-fns/subMonths";
import subDays from "date-fns/subDays";
import SimbarDatePicker from "@/components/SimbarDatePicker";

const allFilters = [
    {
        text: "Customizado",
        value: "custom",
        disabled: false
    },
    {
        text: "Último mês",
        value: "month",
        disabled: false
    },
    {
        text: "Última semana",
        value: "week",
        disabled: false
    },
    {
        text: "Último dia",
        value: "day",
        disabled: false
    }
];
const allowed = allFilters.map(item => item.value);

let uniqueId = 0;

export default {
    name: "DateRangeSelector",
    components: {
        SimbarDatePicker
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        filters: {
            type: Array,
            default() {
                return [...allowed];
            },
            validator(value) {
                if (value.length === 0) {
                    return false;
                }
                return value.every(item => allowed.includes(item));
            }
        },
        size: {
            type: String,
            default: "md"
        }
    },
    data() {
        return {
            intervalFilter: "day",
            intervalFilters: [],
            startDate: "",
            endDate: ""
        };
    },
    computed: {
        value() {
            const data = {};

            if (this.intervalFilter === "custom") {
                if (this.startDate !== "") {
                    data.startDate = this.startDate;
                }
                if (this.endDate !== "") {
                    data.endDate = this.endDate;
                }
            } else {
                const today = new Date();
                const amount = 1;
                const options = { representation: "date" };

                switch (this.intervalFilter) {
                    case "month":
                        data.startDate = formatISO(
                            subMonths(today, amount),
                            options
                        );
                        break;
                    case "week":
                        data.startDate = formatISO(
                            subWeeks(today, amount),
                            options
                        );
                        break;
                    default:
                        data.startDate = formatISO(
                            subDays(today, amount),
                            options
                        );
                        break;
                }
            }

            return data;
        }
    },
    watch: {
        disabled(disabled) {
            for (const filter of this.intervalFilters) {
                if (filter.value !== this.intervalFilter) {
                    this.$set(filter, "disabled", disabled);
                }
            }
        },
        filters: {
            deep: true,
            immediate: true,
            handler(value, oldValue) {
                if (
                    !Array.isArray(oldValue) ||
                    value.length !== oldValue.length ||
                    value.some((item, index) => item !== oldValue[index])
                ) {
                    this.intervalFilters = allFilters.filter(item =>
                        value.includes(item.value)
                    );
                    this.intervalFilter = this.intervalFilters[
                        this.intervalFilters.length - 1
                    ].value;
                }
            }
        }
    },
    created() {
        this.baseId = ++uniqueId;
    },
    methods: {
        onChange() {
            this.$emit("change", this.value);
        }
    }
};
</script>
